import React from 'react';
import { ArrowRight } from 'lucide-react';
import { APPROACHES, SIGNATURE_SOLUTIONS, DIFFERENTIATORS, STATS } from '../mock/mock';
import * as Icons from 'lucide-react';

export const ApproachSection = () => (
  <section className="py-16 md:py-24 bg-[#FAF6F1]">
    <div className="max-w-7xl mx-auto px-4">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <div className="text-xs uppercase tracking-[0.24em] text-[#C58B76] mb-3">Our approach</div>
        <h2 className="font-serif-display text-3xl md:text-5xl text-[#2C2416] leading-tight">Three ways to make it yours</h2>
        <p className="text-[#5B4A3A] mt-4">Whether you want it fast, personalised, or fully bespoke - we have you covered.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {APPROACHES.map((a, i) => (
          <div key={i} className="group bg-white rounded-2xl overflow-hidden border border-[#EFE3D2] hover:shadow-xl transition-shadow">
            <div className="aspect-[4/3] overflow-hidden">
              <img src={a.img} alt={a.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-3">
                <span className="font-serif-display text-3xl text-[#C58B76]">0{i + 1}</span>
                <h3 className="font-serif-display text-2xl text-[#2C2416]">{a.title}</h3>
              </div>
              <p className="text-sm text-[#5B4A3A] mt-3 leading-relaxed">{a.desc}</p>
              <a href="#enquire" className="inline-flex items-center gap-2 mt-5 text-xs uppercase tracking-widest text-[#2C2416] group-hover:text-[#C58B76] transition-colors">
                {a.cta} <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const SignatureSolutions = () => (
  <section className="py-16 md:py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
        <div>
          <div className="text-xs uppercase tracking-[0.24em] text-[#C58B76] mb-3">Signature Solutions</div>
          <h2 className="font-serif-display text-3xl md:text-5xl text-[#2C2416] leading-tight">Premium options built for your team</h2>
        </div>
        <p className="text-[#5B4A3A] max-w-sm">Customized to suit corporate standards, delivered end to end.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-4 md:gap-5">
        {SIGNATURE_SOLUTIONS.map((s, i) => (
          <a href="#enquire" key={i} className="group rounded-2xl overflow-hidden bg-[#FAF6F1] border border-[#EFE3D2] hover:border-[#C58B76] transition-colors">
            <div className="aspect-[5/3] overflow-hidden">
              <img src={s.img} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-5">
              <h4 className="font-serif-display text-xl text-[#2C2416]">{s.title}</h4>
              <p className="text-sm text-[#5B4A3A] mt-1.5 leading-relaxed">{s.desc}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export const StatsBar = () => (
  <section className="py-14 bg-[#F4D5C5]">
    <div className="max-w-7xl mx-auto px-4 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
      {STATS.map((s, i) => (
        <div key={i} className="border-r last:border-r-0 md:border-r border-[#E4B69A]/50 md:last:border-r-0 last:pr-0">
          <div className="font-serif-display text-4xl md:text-5xl text-[#2C2416]">{s.value}</div>
          <div className="text-xs md:text-sm uppercase tracking-widest text-[#7A5C4C] mt-2">{s.label}</div>
        </div>
      ))}
    </div>
  </section>
);

export const Differentiators = () => (
  <section className="py-16 md:py-20 bg-[#FAF6F1]">
    <div className="max-w-7xl mx-auto px-4">
      <div className="text-center mb-10">
        <h2 className="font-serif-display text-3xl md:text-4xl text-[#2C2416]">What sets us apart</h2>
        <p className="text-[#5B4A3A] mt-2">Little things, done really well</p>
      </div>
      <div className="grid md:grid-cols-4 gap-4">
        {DIFFERENTIATORS.map((d, i) => {
          const Icon = Icons[d.icon] || Icons.Sparkles;
          return (
            <div key={i} className="bg-white rounded-xl border border-[#EFE3D2] p-6 hover:border-[#C58B76] transition-colors">
              <div className="w-12 h-12 rounded-full pastel-blush flex items-center justify-center mb-4">
                <Icon className="w-5 h-5 text-[#7A5C4C]" />
              </div>
              <h4 className="font-serif-display text-xl text-[#2C2416]">{d.title}</h4>
              <p className="text-sm text-[#5B4A3A] mt-1">{d.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
